module.exports = __webpack_public_path__ + "static/media/testimonial-a.caa93328.png";